import personProfileLight from "../../../../contents/images/docs/data/people/person-profile-light-mode.png";
import personProfileDark from "../../../../contents/images/docs/data/people/person-profile-dark-mode.png";
import * as React from 'react';
export default {
  personProfileLight,
  personProfileDark,
  React
};